import React from 'react'

import { CheckboxFilter } from '@lifebit-ai/lds'
import type { Option } from 'modules/types'
import { useGetRequestersFromExportRequests } from 'services/results/hooks/useGetRequestersFromExportRequests'

interface RequestedByFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const RequestedByFilter = ({ onApply, onReset }: RequestedByFilterProps) => {
  const requestersFromExportRequestsQuery = useGetRequestersFromExportRequests()

  const options =
    requestersFromExportRequestsQuery.data?.data.map(item => ({
      label: item.email,
      value: item._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Requested by"
      loading={requestersFromExportRequestsQuery.isLoading}
      onApply={onApply}
      onReset={onReset}
      options={options}
      searchFieldPlaceholder="Search by email"
    />
  )
}
